module.exports = __webpack_public_path__ + "img/levels-of-detail.es.074f7175.png";